import { create } from "zustand";
import { persist } from "zustand/middleware";

interface BrowserWarningState {
  dismissed: boolean;
  dismiss: () => void;
  reset: () => void;
}

/**
 * Zustand store for browser warning dismissal state.
 * Persisted to localStorage for cross-session persistence.
 *
 * Follows MAX pattern of using Zustand for all state management.
 */
export const useBrowserWarningStore = create<BrowserWarningState>()(
  persist(
    (set) => ({
      dismissed: false,
      dismiss: () => set({ dismissed: true }),
      reset: () => set({ dismissed: false }),
    }),
    {
      name: "max-browser-warning", // localStorage key
    },
  ),
);
